import React from "react";
import { SOCIALS, ARTIST } from "../data/content";
import {
  InstagramIcon,
  TikTokIcon,
  TwitterIcon,
  FacebookIcon,
} from "./icons/PlatformIcons";

const ICONS = {
  instagram: InstagramIcon,
  tiktok: TikTokIcon,
  twitter: TwitterIcon,
  facebook: FacebookIcon,
};

const MarqueeLine = () => (
  <div className="overflow-hidden border-y border-white/5 py-8">
    <div className="marquee-track flex whitespace-nowrap gap-12 text-[#C5A059]/40">
      {Array.from({ length: 2 }).flatMap((_, i) =>
        Array.from({ length: 8 }).map((__, j) => (
          <span
            key={`${i}-${j}`}
            className="font-display uppercase text-6xl md:text-8xl tracking-tighter"
          >
            {ARTIST.name} <span className="text-[#C5A059]/20">★</span>
          </span>
        ))
      )}
    </div>
  </div>
);

export default function Socials() {
  return (
    <section
      id="connect"
      data-testid="socials-section"
      className="relative pt-24 md:pt-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-4">
              <span className="font-display text-[#C5A059] text-lg md:text-xl tracking-tight">
                Ch. 04
              </span>
              <span className="h-px w-16 bg-[#C5A059]/40" />
              <span className="text-[10px] uppercase tracking-[0.4em] text-[#C5A059]">
                Connect
              </span>
            </div>
            <h2 className="font-display uppercase font-semibold tracking-tighter text-[#F5F5F0] text-4xl md:text-6xl">
              Stay <span className="text-[#C5A059]">Close</span>
            </h2>
            <p className="mt-6 text-sm md:text-base text-[#F5F5F0]/60 leading-relaxed max-w-md">
              Follow the journey. Tap in for behind-the-scenes, surprise drops,
              and first looks at every move before the world catches up.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {SOCIALS.map((s) => {
              const Icon = ICONS[s.id];
              return (
                <a
                  key={s.id}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`social-link-${s.id}`}
                  className="group flex items-center justify-between border border-white/10 hover:border-[#C5A059] p-6 transition-all duration-500 bg-[#0a0a0a] hover:bg-[#0e0d0a]"
                >
                  <div className="flex items-center gap-5">
                    <span className="w-12 h-12 grid place-items-center border border-white/10 group-hover:border-[#C5A059] group-hover:text-[#C5A059] text-[#F5F5F0]/80 transition-colors duration-500">
                      {Icon && <Icon width="22" height="22" />}
                    </span>
                    <div>
                      <div className="text-[10px] uppercase tracking-[0.3em] text-[#F5F5F0]/50">
                        {s.name}
                      </div>
                      <div className="font-display text-lg text-[#F5F5F0] group-hover:text-[#C5A059] transition-colors duration-500">
                        {s.handle}
                      </div>
                    </div>
                  </div>
                  <span className="text-[#F5F5F0]/30 group-hover:text-[#C5A059] transition-all duration-500 group-hover:translate-x-1">
                    →
                  </span>
                </a>
              );
            })}
          </div>
        </div>
      </div>

      <MarqueeLine />

      <footer className="max-w-7xl mx-auto px-6 md:px-12 py-10 flex flex-wrap items-center justify-between gap-4">
        <span className="text-[11px] uppercase tracking-[0.3em] text-[#F5F5F0]/40">
          © {new Date().getFullYear()} {ARTIST.name}. All Rights Reserved.
        </span>
        <span className="text-[11px] uppercase tracking-[0.3em] text-[#F5F5F0]/40">
          Crafted in the dark · Forged in <span className="text-[#C5A059]">gold</span>
        </span>
      </footer>
    </section>
  );
}
